export default "__VITE_ASSET__D83C8N6F__"